import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppStore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 24,
	viewBox: "0 0 20 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.3086 12.763C16.3204 11.8431 16.5648 10.9411 17.0189 10.141C17.473 9.34093 18.1221 8.66869 18.9058 8.18687C18.4079 7.47582 17.7511 6.89066 16.9875 6.47785C16.224 6.06505 15.3746 5.83597 14.507 5.80883C12.6563 5.61456 10.8621 6.91628 9.91895 6.91628C8.95759 6.91628 7.50554 5.82812 5.9419 5.86028C4.93051 5.89296 3.94482 6.18707 3.08089 6.71395C2.21695 7.24083 1.50423 7.98252 1.01216 8.86675C-1.11931 12.5571 0.47058 17.9808 2.51239 20.9639C3.53395 22.4246 4.72786 24.0562 6.29008 23.9984C7.81881 23.9349 8.38976 23.0235 10.235 23.0235C12.0632 23.0235 12.5989 23.9984 14.1928 23.9616C15.8332 23.9349 16.8667 22.4944 17.8525 21.0198C18.5865 19.979 19.1513 18.8287 19.526 17.6115C18.5729 17.2084 17.7596 16.5337 17.1875 15.6715C16.6154 14.8093 16.3097 13.7977 16.3086 12.763Z",
		fill: "#404040"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.298 3.84713C14.1924 2.77342 14.633 1.39335 14.5263 0C13.1599 0.143519 11.8976 0.796596 10.9912 1.82911C10.5479 2.33351 10.2085 2.92033 9.9922 3.55601C9.77591 4.19168 9.68703 4.86375 9.73064 5.5338C10.4141 5.54084 11.0903 5.3927 11.7082 5.10054C12.3261 4.80838 12.8697 4.37982 13.298 3.84713Z",
		fill: "#404040"
	})]
});
export default SvgAppStore;
